<template>
  <div>
    <p>Redirect not allowed. Missing tracking data.</p>
  </div>
</template>

<script>
import { getTrackingData, buildTracking, getCookieDomain, TT_COOKIE_MAX_AGE, TT_P3P_HEADER } from '~/lib/util/tradetracker'

export default {
  layout: 'empty',

  middleware({ app, query, req, res, redirect }) {
    const trackingData = getTrackingData(query)
    if (!trackingData) {
      return
    }

    const { cookieName, cookieValue, trackBackURL } = buildTracking(trackingData)
    const host = process.server ? (req && req.headers.host) || '' : window.location.host
    const domain = getCookieDomain(host)

    app.$cookies.set(cookieName, cookieValue, {
      path: '/',
      maxAge: TT_COOKIE_MAX_AGE,
      ...(domain && { domain })
    })

    if (process.server && res) {
      res.setHeader('P3P', TT_P3P_HEADER)
    }

    redirect(301, trackBackURL)
  },

  head() {
    return {
      title: 'Subscriptions',
      meta: [{ hid: 'robots', name: 'robots', content: 'noindex, nofollow' }]
    }
  }
}
</script>
